module.exports = __webpack_public_path__ + "img/elegant@2x.1e7b3da.webp";